import {Button, Card, Col, Divider, Form, Input, message, Modal, Row, Space, Spin, Upload} from "antd";
import {DownloadOutlined, ExclamationCircleOutlined, PlusOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import modal from "antd/es/modal";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import ErrorHandler from "../../util/ErrorHandler";
import {OtherRequestDto} from "../../dto/OtherRequestDto";
import {
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES, ALLOWED_IMAGE_TYPES_TEXT,
    DOC_CODE_NIC_VERIFICATION_FRONT_DOC,
    DOCUMENT_TYPES,
    PREVIEW_DOC_TYPES
} from "../../util/Constants";
import {DefaultDocumentDto} from "../../dto/DefaultDocumentDto";
import {
    MSG_ALLOWED_DOCUMENT_TYPES_ERROR,
    MSG_ALLOWED_IMAGE_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR, MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../util/Messages";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import {toNumber} from "lodash";
import customerService from "../../service/customerService";
import {CustomerDto} from "../../dto/CustomerDto";
import PreviewModalComp from "../common/preview/PreviewModalComp";

const {TextArea} = Input;

interface RequestProps {
    cin: string
}

const OtherRequestComp = (props: RequestProps) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState<boolean>(false)
    const [otherRequestUploadedList, setOtherRequestUploadedList] = useState<DefaultDocumentDto[]>()
    const [jobNumber, setJobNumber] = useState<number>()
    const [uploadDocumentDetailId, setUploadDocumentDetailId] = useState<number>()
    const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');
    const configs = {
        name: 'file',
        multiple: false,
        maxCount: 1
    };
    const submitRequest = () => {
        form.validateFields().then(() => {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to lodge a request?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {

                    setLoading(true)
                    let fieldsValue = form.getFieldsValue();

                    let otherRequestDto = {} as OtherRequestDto
                    otherRequestDto.otherRequest = fieldsValue.otherRequest
                    if (typeof uploadDocumentDetailId === "number") {
                        otherRequestDto.uploadDocumentDetailId = uploadDocumentDetailId
                    }

                    customerChangeRequestService.submitOtherRequest(otherRequestDto, props.cin).then((res) => {
                        if (res.data.results) {
                            message.success("Request submitted successfully")
                            setLoading(false)
                            form.resetFields()
                            setOtherRequestUploadedList([])
                            setUploadDocumentDetailId(undefined)
                        } else {
                            message.error("Request submission failure")
                            setLoading(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setLoading(false)

                    })


                },
                onCancel() {

                }
            });
        }).catch(() => {

        })

    }
    const beforeUploadUtilityBill = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.OTHER_REQUEST, ALLOWED_IMAGE_TYPES);
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setLoading(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(JSON.stringify(allowedDocTypes) === JSON.stringify(ALLOWED_IMAGE_TYPES) ? MSG_ALLOWED_IMAGE_TYPES_ERROR : MSG_ALLOWED_DOCUMENT_TYPES_ERROR);
            setLoading(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 <= uploadFileSize;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setLoading(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);

        formData.append("jobNo", JSON.stringify(jobNumber));
        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, false)
                setUploadDocumentDetailId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number, init: boolean) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.OTHER_REQUEST) {
            setOtherRequestUploadedList(defaultFileList)
            form.setFieldsValue({uploadUtilityBill: defaultFileList})

        }
    };

    useEffect(() => {
        fetchCustomerDetailsByCIN()
    }, []);

    const fetchCustomerDetailsByCIN = () => {
        customerService.getExactCustomerByCin(props.cin).then(res => {
            if (res.data.results.customerMstDto != null) {
                const customerDto = res.data.results.customerMstDto as CustomerDto
                setJobNumber(customerDto.id)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const onRemove = () => {
        setLoading(true)
        if (otherRequestUploadedList) {
            documentService.deleteDocumentById(otherRequestUploadedList[0].uid).then(res => {
                if (res.data !== null) {
                    setOtherRequestUploadedList([])
                    setUploadDocumentDetailId(undefined)
                    setLoading(false)
                } else {
                    message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                    setLoading(false)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                setLoading(false)
            })
        }

        return true;
    };
    const onPreview = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    return (
        <>
            <Spin spinning={isLoading}>
                <Row gutter={[24, 12]}>
                    <Col span={24}>
                        <Card title="Other Requests">
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="Enter your request"
                                            name={"otherRequest"}
                                            rules={[
                                                {required: true, message: 'Please enter request'},
                                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                                {max: 256, message: 'The maximum length is 256 characters'},
                                            ]}>
                                            <TextArea rows={4}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Upload Attachment (Optional)"
                                            name={"otherRequestAttachment"}
                                        >
                                            <Upload {...configs}
                                                    className='upload_comp'
                                                    accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                    listType="picture"
                                                    onRemove={onRemove}
                                                    onPreview={(e: any) => {
                                                        onPreview(otherRequestUploadedList ? otherRequestUploadedList[0].uid :'',
                                                            otherRequestUploadedList ? otherRequestUploadedList[0].name :'')
                                                    }}
                                                    fileList={otherRequestUploadedList && otherRequestUploadedList?.length > 0 ? otherRequestUploadedList : undefined}
                                                    beforeUpload={beforeUploadUtilityBill}
                                            >
                                                {(undefined != otherRequestUploadedList ? otherRequestUploadedList.length : [].length) < 1 &&
                                                    <Button>
                                                        <div className='upload-btn-div'>
                                                            <div className="upload-icon-div">
                                                                <PlusOutlined
                                                                    style={{fontSize: 20, color: '#757575'}}/>
                                                            </div>
                                                            <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the Attachment {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Button>
                                                }
                                            </Upload>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            {/*<Button size={'large'}*/}
                            {/*        style={{*/}
                            {/*            width: 120,*/}
                            {/*            marginRight: 8*/}
                            {/*        }}>Cancel</Button>*/}
                            <Button onClick={submitRequest} size={'large'} type="success"
                                    style={{
                                        width: 120,
                                        background: "#FF7400",
                                        color: "white",
                                    }}>Submit</Button>
                        </Space>
                    </Col>
                </Row>
            </Spin>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={previewTitle}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </>
    )
}
export default OtherRequestComp;